export default function hasOwnDeepProperty(source, propertyPath) {
    if (!propertyPath)
        return false;

    let obj = source

    let properties = propertyPath.split('.');
    for (let i = 0; i < properties.length; i++) {
        let prop = properties[i];

        if (!obj || !obj.hasOwnProperty(prop)) {
            return false;
        } else {
            obj = obj[prop];
        }
    }

    return true;
}
